import { Form } from 'factorial-form'
import { ContractFlowCustomFieldFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import CentsCustomField from './CentsCustomField'
import DateCustomField from './DateCustomField'
import LongTextCustomField from './LongTextCustomField'
import SingleChoiceCustomField from './SingleChoiceCustomField'
import TextCustomField from './TextCustomField'

interface Props {
  form: Form
  field: ContractFlowCustomFieldFragment
}

const CustomField = ({ form, field }: Props) => {
  switch (field.fieldType) {
    case 'text':
      return <TextCustomField form={form} field={field} />

    case 'cents':
      return <CentsCustomField form={form} field={field} />

    case 'date':
      return <DateCustomField form={form} field={field} />

    case 'long_text':
      return <LongTextCustomField form={form} field={field} />

    case 'single_choice':
      return <SingleChoiceCustomField form={form} field={field} />

    default:
      return null
  }
}

export default observer(CustomField)
